// Filtra vendedores por estado (considerando múltiplos estados separados por '|')
function filtrarVendedoresPorEstado(nomeEstado) {
    const alvo = normalize(nomeEstado);
    if (!Array.isArray(vendedores)) return [];
    return vendedores.filter(v => {
        const estadosString = (v.state || '').toString();
        const estados = estadosString.split('|').map(e => normalize(e));
        return estados.includes(alvo);
    });
}

// Mapeamento de estados brasileiros para suas capitais com coordenadas
const estadosCapitais = {
    'Acre': { lat: -9.9755, lng: -67.8243, capital: 'Rio Branco' },
    'Alagoas': { lat: -9.5713, lng: -35.7353, capital: 'Maceió' },
    'Amapá': { lat: 0.0389, lng: -51.0664, capital: 'Macapá' },
    'Amazonas': { lat: -3.1190, lng: -60.0217, capital: 'Manaus' },
    'Bahia': { lat: -12.9777, lng: -38.5016, capital: 'Salvador' },
    'Ceará': { lat: -3.7319, lng: -38.5267, capital: 'Fortaleza' },
    'Distrito Federal': { lat: -15.7801, lng: -47.9292, capital: 'Brasília' },
    'Espírito Santo': { lat: -20.3155, lng: -40.3128, capital: 'Vitória' },
    'Goiás': { lat: -16.6864, lng: -49.2643, capital: 'Goiânia' },
    'Maranhão': { lat: -2.5387, lng: -44.2825, capital: 'São Luís' },
    'Mato Grosso': { lat: -15.6014, lng: -56.0979, capital: 'Cuiabá' },
    'Mato Grosso do Sul': { lat: -20.4697, lng: -54.6201, capital: 'Campo Grande' },
    'Minas Gerais': { lat: -19.9167, lng: -43.9345, capital: 'Belo Horizonte' },
    'Pará': { lat: -1.4558, lng: -48.5044, capital: 'Belém' },
    'Paraíba': { lat: -7.1195, lng: -34.8450, capital: 'João Pessoa' },
    'Paraná': { lat: -25.4244, lng: -49.2654, capital: 'Curitiba' },
    'Pernambuco': { lat: -8.0476, lng: -34.8770, capital: 'Recife' },
    'Piauí': { lat: -5.0892, lng: -42.8019, capital: 'Teresina' },
    'Rio de Janeiro': { lat: -22.9068, lng: -43.1729, capital: 'Rio de Janeiro' },
    'Rio Grande do Norte': { lat: -5.7945, lng: -35.2110, capital: 'Natal' },
    'Rio Grande do Sul': { lat: -30.0346, lng: -51.2177, capital: 'Porto Alegre' },
    'Rondônia': { lat: -8.7612, lng: -63.9021, capital: 'Porto Velho' },
    'Roraima': { lat: 2.8235, lng: -60.6758, capital: 'Boa Vista' },
    'Santa Catarina': { lat: -27.5954, lng: -48.5480, capital: 'Florianópolis' },
    'São Paulo': { lat: -23.5505, lng: -46.6333, capital: 'São Paulo' },
    'Sergipe': { lat: -10.9472, lng: -37.0731, capital: 'Aracaju' },
    'Tocantins': { lat: -10.1839, lng: -48.3336, capital: 'Palmas' }
};

// Inicializa o mapa com Leaflet
const initialCenter = { lat: -15.0, lng: -60.0 };
const map = L.map('mapContainer', {
    zoomControl: true
}).setView([initialCenter.lat, initialCenter.lng], 3.8);

L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '© OpenStreetMap'
}).addTo(map);

// ======= ADICIONAR BORDAS DOS ESTADOS E PAÍSES =======
// URLs dos dados GeoJSON
const BR_STATES_URL = 'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson';
const COUNTRIES_URL = 'https://raw.githubusercontent.com/datasets/geo-countries/master/data/countries.geojson';

// Países da América Latina para destacar
const TARGET_COUNTRIES = new Set([
    'bolivia','bolívia','plurinational state of bolivia',
    'peru',
    'colombia','colômbia',
    'venezuela','bolivarian republic of venezuela',
    'equador','ecuador',
    'cuba',
    'republica dominicana','república dominicana','dominican republic',
    'jamaica',
    'paraguai','paraguay',
    'uruguai','uruguay',
    'chile',
    'argentina',
    'mexico','méxico','united mexican states',
    'hondura','honduras',
    'nicaragua','nicarágua',
    'costa rica',
    'guiana','guyana',
    'guiana francesa','french guiana'
].map(s => (s||'').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim()));

function normalize(s){ return (s||'').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim(); }
function countryName(p){ return p?.ADMIN ?? p?.name ?? p?.NAME_PT ?? p?.NAME_EN ?? 'País'; }
function isTarget(p){ return TARGET_COUNTRIES.has(normalize(countryName(p))); }

// Estilos para as bordas
const STATE_STYLE_WITH_REP = { weight: 1.8, color: '#ffffff', fillColor: '#0F76B8', fillOpacity: 0.9 }; // Mais escuro para estados COM representantes
const STATE_STYLE_DEFAULT = { weight: 1.8, color: '#ffffff', fillColor: '#0e3a7c', fillOpacity: 0.8 }; // Cor original para TODOS os estados
const COUNTRY_STYLE = { weight: 1.6, color: '#ffffff', fillColor: '#89c6ff', fillOpacity: 0.8 };
const COUNTRY_STYLE_WITH_REP = { weight: 1.6, color: '#ffffff', fillColor: '#3d9aff', fillOpacity: 0.95 };
const HOVER_STROKE_STATE = { weight: 3.2, color: '#333333' };
const HOVER_STROKE_COUNTRY = { weight: 3.0, color: '#333333' };

function addHoverGlow(layer, base, glow){
    layer.on('mouseover', () => {
        layer.setStyle({
            ...base,
            fillColor: '#1a1a1a',
            color: '#ffffff', // Manter borda branca
            weight: base.weight
        });
        if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) layer.bringToFront();
    });
    layer.on('mouseout', () => {
        layer.setStyle(base);
    });
}

// Função para verificar se um estado tem representantes
function temRepresentantes(nomeEstado) {
    if (typeof vendedores === 'undefined' || !vendedores || vendedores.length === 0) {
        return false;
    }

    const nomeNormalizado = normalize(nomeEstado);

    const temRep = vendedores.some(vendedor => {
        const estadosString = (vendedor.state || '').toString();
        const estados = estadosString.split('|').map(e => normalize(e));
        return estados.includes(nomeNormalizado);
    });

    return temRep;
}

// Função para verificar se um país tem representantes
function temRepresentantesPais(nomePais) {
    if (typeof vendedores === 'undefined' || !vendedores || vendedores.length === 0) {
        return false;
    }
    const alvo = normalize(nomePais);
    return vendedores.some(v => normalize(v.country || '') === alvo);
}

function onEachState(f,l){
    const nome = f?.properties?.nome ?? f?.properties?.name ?? f?.properties?.NOME_UF ?? 'Estado';

    // Determinar estilo baseado na presença de representantes
    const temRep = temRepresentantes(nome);
    const style = temRep ? STATE_STYLE_WITH_REP : STATE_STYLE_DEFAULT;

    // Aplicar o estilo apropriado
    l.setStyle(style);

    // Tooltip removido - não mostrar mais informações sobre representantes
    addHoverGlow(l, style, HOVER_STROKE_STATE);

    // Clique no estado: mostrar apenas vendedores daquele estado
    l.on('click', () => {
        const vendedoresDoEstado = filtrarVendedoresPorEstado(nome).map(v => ({
            ...v,
            tipo: 'estado',
            estado: nome,
            isCapital: true,
            localizacao: nome
        }));
        atualizarCards(vendedoresDoEstado);
    });
}

function onEachCountry(f,l){
    const nome = countryName(f.properties);
    const hasRep = temRepresentantesPais(nome);
    const baseStyle = hasRep ? COUNTRY_STYLE_WITH_REP : COUNTRY_STYLE;
    l.setStyle(baseStyle);
    addHoverGlow(l, baseStyle, HOVER_STROKE_COUNTRY);

    // Clique no país: mostrar apenas vendedores daquele país
    l.on('click', () => {
        const vendedoresDoPais = filtrarVendedoresPorPais(nome).map(v => ({
            ...v,
            tipo: 'pais',
            pais: nome,
            isCapital: false,
            localizacao: nome
        }));
        atualizarCards(vendedoresDoPais);
    });
}

// Carregar bordas imediatamente
async function loadMapBorders() {
    try {
        const [br, world] = await Promise.all([
            fetch(BR_STATES_URL).then(r => r.json()),
            fetch(COUNTRIES_URL).then(r => r.json())
        ]);

        // Adicionar estados brasileiros com estilo dinâmico
        statesLayer = L.geoJSON(br, {
            style: (feature) => {
                const nome = feature?.properties?.nome ?? feature?.properties?.name ?? feature?.properties?.NOME_UF ?? 'Estado';
                const temRep = temRepresentantes(nome);
                return temRep ? STATE_STYLE_WITH_REP : STATE_STYLE_DEFAULT;
            },
            onEachFeature: onEachState
        }).addTo(map);

        // Filtrar e adicionar países
        const filtered = {
            type: 'FeatureCollection',
            features: world.features.filter(f => isTarget(f.properties))
        };

        countriesLayer = L.geoJSON(filtered, {
            style: (feature) => {
                const nome = countryName(feature?.properties || {});
                const hasRep = temRepresentantesPais(nome);
                return hasRep ? COUNTRY_STYLE_WITH_REP : COUNTRY_STYLE;
            },
            onEachFeature: onEachCountry
        }).addTo(map);


    } catch(e) {
        console.error('Erro ao carregar bordas:', e);
    }
}

// Variável para armazenar a camada de estados
let statesLayer = null;
let countriesLayer = null;

// Função para recolorir os estados baseado nos vendedores
function recolorirEstados() {
    if (!statesLayer) return;


    statesLayer.eachLayer(function(layer) {
        const feature = layer.feature;
        const nome = feature?.properties?.nome ?? feature?.properties?.name ?? feature?.properties?.NOME_UF ?? 'Estado';
        const temRep = temRepresentantes(nome);
        const style = temRep ? STATE_STYLE_WITH_REP : STATE_STYLE_DEFAULT;

        layer.setStyle(style);

    });
}


// Carregar bordas inicialmente (sem cores dinâmicas ainda)
loadMapBorders();

// Cache para evitar geocodificações repetidas
const geocodeCache = {};
const reverseGeocodeCache = {};

// Função de geocodificação com retry e cache (Nominatim)
function geocodeAddress(address, callback, retries = 3, delay = 1000) {
    if (geocodeCache[address]) {
        callback(geocodeCache[address]);
        return;
    }

    const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1&addressdetails=1`;

    fetch(url, {
        headers: {
            'Accept': 'application/json'
        }
    })
        .then(res => {
            if ((res.status === 429 || res.status >= 500) && retries > 0) {
                return new Promise(resolve => setTimeout(resolve, delay))
                    .then(() => geocodeAddress(address, callback, retries - 1, delay * 2));
            }
            return res.json();
        })
        .then(data => {
            if (Array.isArray(data) && data.length > 0) {
                const position = data[0];
                const location = {
                    lat: parseFloat(position.lat),
                    lng: parseFloat(position.lon),
                    address: position.address || {},
                    displayName: position.display_name || ''
                };
                geocodeCache[address] = location;
                callback(location);
            } else {
                console.error('Endereço não encontrado:', address);
                callback(null);
            }
        })
        .catch(err => {
            console.error('Erro ao geocodificar:', err);
            callback(null);
        });
}

// Função de geocodificação reversa (obter nome da cidade das coordenadas)
function reverseGeocodeDetailed(lat, lng, callback, retries = 3, delay = 1000) {
    const cacheKey = `${lat},${lng}`;

    if (reverseGeocodeCache[cacheKey]) {
        callback(reverseGeocodeCache[cacheKey]);
        return;
    }

    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&addressdetails=1`;

    fetch(url, {
        headers: {
            'Accept': 'application/json'
        }
    })
        .then(res => {
            if ((res.status === 429 || res.status >= 500) && retries > 0) {
                return new Promise(resolve => setTimeout(resolve, delay))
                    .then(() => reverseGeocodeDetailed(lat, lng, callback, retries - 1, delay * 2));
            }
            return res.json();
        })
        .then(data => {
            if (data && data.address) {
                const resultado = {
                    lat,
                    lng,
                    address: data.address || {},
                    displayName: data.display_name || ''
                };
                reverseGeocodeCache[cacheKey] = resultado;
                callback(resultado);
            } else {
                console.error('Erro na geocodificação reversa:', data);
                callback(null);
            }
        })
        .catch(err => {
            console.error('Erro ao fazer geocodificação reversa:', err);
            callback(null);
        });
}

// Removidos: não exibiremos mais marcadores de representantes em países

// Função para remover tags HTML
function removeHtmlTags(str) {
    if (!str) return '';
    return str.replace(/<[^>]*>/g, '');
}

// Removido: não criaremos marcadores para estados brasileiros

// Função para calcular distância entre dois pontos (fórmula de Haversine)
function calcularDistancia(lat1, lng1, lat2, lng2) {
    const R = 6371; // Raio da Terra em km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
              Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
              Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
}

// Encontrar o estado brasileiro mais próximo de uma coordenada
function encontrarEstadoMaisProximo(lat, lng) {
    let melhorEstado = null;
    let menorDistancia = Infinity;

    Object.keys(estadosCapitais).forEach(nomeEstado => {
        const info = estadosCapitais[nomeEstado];
        const distancia = calcularDistancia(lat, lng, info.lat, info.lng);
        if (distancia < menorDistancia) {
            menorDistancia = distancia;
            melhorEstado = nomeEstado;
        }
    });

    return melhorEstado;
}


// Função para calcular vendedores mais próximos (estados e países)
function calcularVendedoresProximos(centro, vendedores, quantidade = 3, raioMaximo = 2000) {
    const todasLocalizacoes = [];

    vendedores.forEach(vendedor => {
        // Localizações nas capitais dos estados
        const estadosString = removeHtmlTags(vendedor.state);
        if (estadosString) {
            const estados = estadosString.split('|').map(estado => estado.trim());

            estados.forEach(estado => {
                const estadoEncontrado = Object.keys(estadosCapitais).find(
                    key => key.toLowerCase() === estado.toLowerCase()
                );

                if (estadoEncontrado) {
                    const capitalInfo = estadosCapitais[estadoEncontrado];
                    const distanciaCapital = calcularDistancia(centro.lat, centro.lng, capitalInfo.lat, capitalInfo.lng);

                    todasLocalizacoes.push({
                        ...vendedor,
                        lat: capitalInfo.lat,
                        lng: capitalInfo.lng,
                        distancia: distanciaCapital,
                        isCapital: true,
                        localizacao: estadoEncontrado,
                        estado: estadoEncontrado,
                        tipo: 'estado'
                    });
                }
            });
        }

        // Localizações nos países
        const paisString = removeHtmlTags(vendedor.country);
        if (paisString) {
            // Para países, vamos usar coordenadas aproximadas da América Latina
            // ou fazer uma geocodificação síncrona aqui (mas isso pode ser lento)
            // Por enquanto, vamos usar coordenadas aproximadas baseadas no país
            let coordenadasPais = null;

            // Coordenadas aproximadas para alguns países da América Latina
            const coordenadasPaises = {
                'argentina': { lat: -34.6037, lng: -58.3816 }, // Buenos Aires
                'chile': { lat: -33.4489, lng: -70.6693 }, // Santiago
                'colombia': { lat: 4.7110, lng: -74.0721 }, // Bogotá
                'peru': { lat: -12.0464, lng: -77.0428 }, // Lima
                'mexico': { lat: 19.4326, lng: -99.1332 }, // Cidade do México
                'uruguay': { lat: -34.9011, lng: -56.1645 }, // Montevidéu
                'paraguay': { lat: -25.2637, lng: -57.5759 }, // Assunção
                'bolivia': { lat: -16.2902, lng: -63.5887 }, // La Paz
                'venezuela': { lat: 10.4806, lng: -66.9036 }, // Caracas
                'ecuador': { lat: -0.1807, lng: -78.4678 }, // Quito
            };

            const paisLower = paisString.toLowerCase();
            coordenadasPais = coordenadasPaises[paisLower];

            if (coordenadasPais) {
                const distanciaPais = calcularDistancia(centro.lat, centro.lng, coordenadasPais.lat, coordenadasPais.lng);

                todasLocalizacoes.push({
                    ...vendedor,
                    lat: coordenadasPais.lat,
                    lng: coordenadasPais.lng,
                    distancia: distanciaPais,
                    isCapital: false,
                    localizacao: paisString,
                    pais: paisString,
                    tipo: 'pais'
                });
            }
        }
    });

    // Filtra apenas localizações dentro do raio máximo
    const localizacoesNoRaio = todasLocalizacoes.filter(v => v.distancia <= raioMaximo);

    // Remove duplicatas baseado no vendedor (mantém apenas a localização mais próxima de cada vendedor)
    const vendedoresUnicos = new Map();
    localizacoesNoRaio.forEach(localizacao => {
        const vendedorId = localizacao.id || localizacao.name; // Use id se disponível, senão use name
        if (!vendedoresUnicos.has(vendedorId) || localizacao.distancia < vendedoresUnicos.get(vendedorId).distancia) {
            vendedoresUnicos.set(vendedorId, localizacao);
        }
    });

    // Ordena por distância e retorna os mais próximos
    return Array.from(vendedoresUnicos.values())
        .sort((a, b) => a.distancia - b.distancia)
        .slice(0, quantidade);
}

// Função para atualizar os cards
function atualizarCards(vendedoresProximos) {
    const cardsContainer = document.querySelector('.cards-endereco .row');
    if (!cardsContainer) return;

    // Limpa os cards existentes
    cardsContainer.innerHTML = '';

    if (vendedoresProximos.length === 0) {
        // Se não há vendedores próximos, mostra mensagem
        cardsContainer.innerHTML = `
            <div class="col-12 text-center">
                <div class="card-endereco">
                    <div class="nome">Nenhum vendedor encontrado</div>
                    <div class="ramo">Não há vendedores próximos nesta região</div>
                    <div class="text-muted">
                        <p>Tente mover o mapa para outra região ou ampliar a área de busca</p>
                    </div>
                </div>
            </div>
        `;
        return;
    }

    // Função para renderizar um card individual
    function renderizarCard(vendedor, cidade = null) {
        const nome = removeHtmlTags(vendedor.name);
        const ramo = removeHtmlTags(vendedor.position);
        const telefone = removeHtmlTags(vendedor.phonesArr);
        const email = removeHtmlTags(vendedor.email);
        const estado = removeHtmlTags(vendedor.state);
        const country = removeHtmlTags(vendedor.country);
        const localizacao = vendedor.isCapital ? vendedor.localizacao : (cidade || 'Carregando...');

        const cardHTML = `
            <div class="col-lg-4">
                    <div class="card-endereco">
                        <div class="nome">${nome}</div>
                        <div class="ramo">${ramo}</div>
                        <div class="localizacao-info">
                            <small font-style: italic;">
                                ${localizacao}
                            </small>
                        </div>
                        <div class="telefone">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.25301 18.494L7.97701 18.917C9.19795 19.6291 10.5866 20.0029 12 20C13.5823 20 15.129 19.5308 16.4446 18.6518C17.7602 17.7727 18.7855 16.5233 19.3911 15.0615C19.9966 13.5997 20.155 11.9911 19.8463 10.4393C19.5376 8.88743 18.7757 7.46197 17.6569 6.34315C16.538 5.22433 15.1126 4.4624 13.5607 4.15372C12.0089 3.84504 10.4004 4.00346 8.93855 4.60896C7.47674 5.21447 6.22731 6.23984 5.34826 7.55544C4.46921 8.87103 4.00001 10.4177 4.00001 12C4.00001 13.436 4.37701 14.813 5.08401 16.024L5.50601 16.748L4.85301 19.149L7.25301 18.494ZM2.00401 22L3.35601 17.032C2.46515 15.5049 1.99711 13.768 2.00001 12C2.00001 6.477 6.47701 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C10.2328 22.0029 8.49667 21.5352 6.97001 20.645L2.00401 22ZM8.39101 7.308C8.52501 7.298 8.66001 7.298 8.79401 7.304C8.84801 7.308 8.90201 7.314 8.95601 7.32C9.11501 7.338 9.29001 7.435 9.34901 7.569C9.64701 8.245 9.93701 8.926 10.217 9.609C10.279 9.761 10.242 9.956 10.124 10.146C10.0429 10.2745 9.95507 10.3986 9.86101 10.518C9.74801 10.663 9.50501 10.929 9.50501 10.929C9.50501 10.929 9.40601 11.047 9.44401 11.194C9.45801 11.25 9.50401 11.331 9.54601 11.399L9.60501 11.494C9.86101 11.921 10.205 12.354 10.625 12.762C10.745 12.878 10.862 12.997 10.988 13.108C11.456 13.521 11.986 13.858 12.558 14.108L12.563 14.11C12.648 14.147 12.691 14.167 12.815 14.22C12.877 14.246 12.941 14.269 13.006 14.286C13.0732 14.3031 13.1439 14.2999 13.2093 14.2767C13.2746 14.2536 13.3316 14.2116 13.373 14.156C14.097 13.279 14.163 13.222 14.169 13.222V13.224C14.2193 13.1771 14.2791 13.1415 14.3443 13.1196C14.4095 13.0977 14.4786 13.09 14.547 13.097C14.607 13.101 14.668 13.112 14.724 13.137C15.255 13.38 16.124 13.759 16.124 13.759L16.706 14.02C16.804 14.067 16.893 14.178 16.896 14.285C16.9 14.352 16.906 14.46 16.883 14.658C16.851 14.917 16.773 15.228 16.695 15.391C16.6416 15.5022 16.5707 15.6042 16.485 15.693C16.3841 15.7989 16.2736 15.8954 16.155 15.981C16.114 16.0119 16.0723 16.0419 16.03 16.071C15.9056 16.1499 15.7778 16.2233 15.647 16.291C15.3895 16.4278 15.1052 16.5063 14.814 16.521C14.629 16.531 14.444 16.545 14.258 16.535C14.25 16.535 13.69 16.448 13.69 16.448C12.2683 16.074 10.9534 15.3735 9.85001 14.402C9.62401 14.203 9.41501 13.989 9.20101 13.776C8.31101 12.891 7.63901 11.936 7.23101 11.034C7.02218 10.5913 6.90938 10.1094 6.90001 9.62C6.89589 9.01285 7.09436 8.42167 7.46401 7.94C7.53701 7.846 7.60601 7.748 7.72501 7.635C7.85201 7.515 7.93201 7.451 8.01901 7.407C8.13469 7.34903 8.26088 7.31502 8.39001 7.307L8.39101 7.308Z" fill="#2476B5"/>
                            </svg>
                            <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.42154 5.69238C6.43625 5.20018 6.88105 4.54481 6.96167 3.42934C7.04229 2.31387 6.42235 1.06733 5.48548 0.462779C5.01566 0.160505 4.42908 5.85101e-06 3.79245 5.85101e-06C2.24399 -0.00266914 0.72332 0.912177 0.259058 2.12662C-0.0467431 2.92912 -0.018943 3.79046 0.0310972 4.51539C0.0366572 4.65181 0.164538 7.92867 1.85479 11.1574L1.91595 11.2751C3.60619 14.5065 6.26666 16.5528 6.36396 16.6277C6.92275 17.0852 7.62053 17.6523 8.48233 17.8957C8.72976 17.9652 8.99108 18 9.26352 18C10.9176 18 12.9081 16.6197 12.9971 14.8408C13.0499 13.7521 12.3827 12.5296 11.4069 11.9305C10.8509 11.5881 10.3839 11.4356 9.89458 11.4356C9.48592 11.4356 9.07726 11.5426 8.60466 11.77C8.47677 11.8315 8.35723 11.8636 8.24325 11.8636C7.43983 11.8636 6.65865 10.3469 6.23886 9.53099L5.88858 8.85957C5.47992 8.09184 4.79604 6.80518 5.03512 6.10165C5.09628 5.92243 5.22138 5.79136 5.4271 5.69238H5.42154ZM4.89334 9.34909L5.23806 10.0071C5.83854 11.1734 6.74483 12.9362 8.23769 12.9362C8.52681 12.9362 8.81594 12.8667 9.0995 12.7303C9.77504 12.4039 10.1253 12.4173 10.8064 12.8346C11.4458 13.2278 11.9212 14.0865 11.8851 14.7927C11.8322 15.852 10.509 16.9327 9.26352 16.9327C9.09672 16.9327 8.94104 16.9113 8.79648 16.8712C8.15985 16.6919 7.58717 16.2238 7.07009 15.8012C7.04507 15.7824 4.48746 13.8056 2.91119 10.7963L2.85003 10.6786C1.27376 7.66652 1.14588 4.51539 1.14588 4.46456C1.1014 3.83059 1.07638 3.10567 1.30712 2.49844C1.61014 1.70932 2.72493 1.07 3.79523 1.07C4.20946 1.07 4.58198 1.16898 4.86832 1.35355C5.47436 1.7441 5.90804 2.62417 5.85522 3.35712C5.79962 4.10611 5.59112 4.41641 4.92392 4.74008C4.44854 4.97013 4.13162 5.31788 3.97593 5.77531C3.59229 6.90415 4.37904 8.37807 4.89612 9.35444L4.89334 9.34909Z" fill="#2476B5" />
                            </svg>
                            <div>
                                <p>${telefone || 'Telefone não informado'}</p>
                            </div>
                        </div>
                        <div class="email">
                            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.937317 13.0156H17.0649C17.5807 13.0156 18.0022 12.5993 18.0022 12.0851V1.09112C18.0022 1.09112 18.0022 1.08676 18.0022 1.08458C18.0022 0.572473 17.5829 0.15625 17.0649 0.15625H0.937317C0.419268 0.158429 0 0.574652 0 1.08894V12.0872C0 12.5993 0.419268 13.0178 0.937317 13.0178V13.0156ZM6.4822 6.09451L0.878049 11.6122V1.90395L6.4822 6.09451ZM17.122 1.96933V11.1851L11.8339 5.97901L17.122 1.96933ZM11.1337 6.50855C11.1424 6.51945 11.1512 6.53252 11.1622 6.54342L16.8498 12.1439H1.58488L7.18902 6.62405L8.83098 7.8531C8.91 7.91194 9.0022 7.94027 9.09439 7.94027C9.18659 7.94027 9.28317 7.90976 9.36 7.85092L11.1315 6.50855H11.1337ZM16.9134 1.0301L9.09439 6.95746L1.17 1.0301H16.9134Z" fill="#2476B5" />
                            </svg>
                            <div>
                                <p>${email || 'Email não informado'}</p>
                            </div>
                        </div>
                        <div class="local">
                            <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 6.14686C0 7.95461 1.1099 9.58077 2.08905 11.0174C2.28063 11.2977 2.46916 11.5754 2.64857 11.8505C3.26281 12.7957 3.87098 13.7463 4.47915 14.6969C4.88358 15.3298 5.28801 15.9626 5.69548 16.5928L5.85969 16.8465C6.04822 17.1375 6.23675 17.4312 6.42224 17.725C6.53475 17.9012 6.74153 18 6.95439 18C6.98176 18 7.01216 18 7.03953 17.9947C7.27976 18.024 7.52911 17.9252 7.65378 17.7276L11.8562 11.1509C11.9718 10.972 12.0873 10.7931 12.2029 10.6168C13.0878 9.26302 14 7.86382 14 6.14953C14 2.75834 10.8588 0 7 0C3.14118 0 0 2.75834 0 6.14686ZM12.7837 6.14686C12.7837 7.5781 11.99 8.79306 11.1477 10.0828C11.0291 10.2644 10.9105 10.4459 10.795 10.6275L7.03953 16.51C7 16.4486 6.96047 16.3872 6.92094 16.3231L6.75977 16.0694C6.3523 15.4393 5.94787 14.8064 5.54344 14.1762C4.93527 13.2256 4.32407 12.2724 3.70982 11.3244C3.52737 11.0441 3.33275 10.7583 3.13814 10.47C2.19548 9.08945 1.22242 7.65821 1.22242 6.14686C1.21633 3.34579 3.81017 1.06809 7 1.06809C10.1898 1.06809 12.7837 3.34579 12.7837 6.14686Z" fill="#2476B5" />
                            </svg>
                            <div>
                                <p>${country || 'Localização não informada'}</p>
                            </div>
                        </div>
                    </div>
            </div>
        `;

        return cardHTML;
    }

    // Processa cada vendedor
    vendedoresProximos.forEach((vendedor, index) => {
        let localizacao = '';

        if (vendedor.tipo === 'estado') {
            // Se é estado, mostra o nome do estado
            localizacao = vendedor.estado;
        } else if (vendedor.tipo === 'pais') {
            // Se é país, mostra o nome do país
            localizacao = vendedor.pais;
        } else {
            // Fallback para casos antigos
            localizacao = vendedor.localizacao || 'Localização';
        }

        const cardHTML = renderizarCard(vendedor, localizacao);
        cardsContainer.innerHTML += cardHTML;
    });
}

// Decide se vai buscar por ESTADO (Brasil) ou PAÍS (fora) e atualiza os cards
function processarLocalizacao(location) {
    if (!location) return;

    const lat = location.lat;
    const lng = location.lng;
    const address = location.address || {};
    const displayName = location.displayName || '';

    // Centraliza o mapa
    map.setView([lat, lng], 5);

    const country = address.country || '';
    const stateFromAddress = address.state || address.region || null;
    const countryNorm = normalize(country);

    if (countryNorm === 'brasil' || countryNorm === 'brazil') {
        // Dentro do Brasil → filtra por ESTADO
        const estadoNome = stateFromAddress || encontrarEstadoMaisProximo(lat, lng);

        if (estadoNome) {
            const vendedoresDoEstado = filtrarVendedoresPorEstado(estadoNome).map(v => ({
                ...v,
                tipo: 'estado',
                estado: estadoNome,
                isCapital: true,
                localizacao: estadoNome
            }));
            atualizarCards(vendedoresDoEstado);
        } else {
            // fallback: usa distância
            const proximos = calcularVendedoresProximos({ lat, lng }, vendedores, 6, 4000);
            atualizarCards(proximos);
        }
    } else if (country) {
        // Fora do Brasil → filtra por PAÍS
        const vendedoresDoPais = filtrarVendedoresPorPais(country).map(v => ({
            ...v,
            tipo: 'pais',
            pais: country,
            isCapital: false,
            localizacao: country
        }));
        atualizarCards(vendedoresDoPais);
    } else {
        // fallback geral
        const proximos = calcularVendedoresProximos({ lat, lng }, vendedores, 6, 4000);
        atualizarCards(proximos);
    }
}

// Controle de geolocalização
let geoStatus = { denied: false };

// Tenta obter localização via navegador + Nominatim reverse
function tentarObterLocalizacaoNavegador(callback) {
    if (!navigator.geolocation || geoStatus.denied) {
        callback(null);
        return;
    }

    navigator.geolocation.getCurrentPosition(
        (pos) => {
            const lat = pos.coords.latitude;
            const lng = pos.coords.longitude;

            reverseGeocodeDetailed(lat, lng, function (info) {
                if (info) {
                    callback(info);
                } else {
                    callback({ lat, lng, address: {}, displayName: '' });
                }
            });
        },
        (err) => {
            if (err.code === 1) {
                geoStatus.denied = true;
            }
            callback(null);
        },
        {
            enableHighAccuracy: true,
            timeout: 8000,
            maximumAge: 600000
        }
    );
}

// Adicionar marcadores dos vendedores que vêm do backend (apenas estados e países)
if (typeof vendedores !== 'undefined' && vendedores.length > 0) {
    // Apenas recolorir estados após load inicial
    setTimeout(() => {
        recolorirEstados();
    }, 500);
}

// Event listener para mudanças no mapa (pan/zoom)
// Não atualizamos mais cards em pan/zoom


// Filtra vendedores por país
function filtrarVendedoresPorPais(nomePais) {
    const alvo = normalize(nomePais);
    if (!Array.isArray(vendedores)) return [];
    return vendedores.filter(v => normalize(v.country || '') === alvo);
}

// Recolorir países quando necessário (se a lista de vendedores mudar no futuro)
function recolorirPaises() {
    if (!countriesLayer) return;
    countriesLayer.eachLayer((layer) => {
        const nome = countryName(layer?.feature?.properties || {});
        const hasRep = temRepresentantesPais(nome);
        const style = hasRep ? COUNTRY_STYLE_WITH_REP : COUNTRY_STYLE;
        layer.setStyle(style);
    });
}

const formBusca = document.getElementById('search-stores');
const inputEndereco = document.getElementById('endereco');

formBusca.addEventListener('submit', function (e) {
    e.preventDefault();

    const endereco = inputEndereco.value.trim();

    if (!endereco) {
        // Se vazio, tenta geolocalização do navegador
        tentarObterLocalizacaoNavegador(function (localInfo) {
            if (localInfo) {
                processarLocalizacao(localInfo);
            } else {
                console.warn('Não foi possível obter sua localização pelo navegador.');
            }
        });
        return;
    }

    // Verifica se é um CEP 
    const cepLimpo = endereco.replace(/\D/g, '');
    
    if (cepLimpo.length === 8 && /^\d{8}$/.test(cepLimpo)) {
        // É UM CEP: Consulta ViaCEP primeiro
        fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`)
            .then(res => res.json())
            .then(data => {
                if (data.erro) {
                    console.warn('CEP não encontrado na base do ViaCEP.');
                    // Tenta busca normal como fallback
                    buscarNoMapa(endereco);
                } else {
                    const termoDeBusca = `${data.logradouro || ''}, ${data.localidade} - ${data.uf}, Brasil`;
                    buscarNoMapa(termoDeBusca);
                }
            })
            .catch(err => {
                console.error('Erro ao consultar ViaCEP:', err);
                buscarNoMapa(endereco);
            });
    } else {
        buscarNoMapa(endereco);
    }
});

// Função wrapper para chamar o geocodeAddress e processar
function buscarNoMapa(termo) {
    geocodeAddress(termo, function (location) {
        if (location) {
            processarLocalizacao(location);
        } else {
            console.warn('Não foi possível localizar o endereço informado.');
            alert('Endereço ou CEP não localizado no mapa.');
        }
    });
}

['focus', 'click'].forEach(evt => {
    inputEndereco.addEventListener(evt, function () {
        if (inputEndereco.value.trim()) return;

        tentarObterLocalizacaoNavegador(function (localInfo) {
            if (localInfo) {
                processarLocalizacao(localInfo);
            }
        });
    });
});


